<section class="vc-admin-user-invitations">
  <header class="vc-admin-user-invitations__header">
    <button pButton type="button" icon="fas fa-user-plus" [routerLink]="createUserLink">
      {{ 'ADMIN.USERS.NEW' | translate }}
    </button>
  </header>

  @if (loading) {
    <p class="vc-admin-user-invitations__state">{{ 'COMMON.LOADING' | translate }}...</p>
  } @else if (!invitations.length) {
    <p class="vc-admin-user-invitations__state">{{ 'ADMIN.USERS.INVITATION.PENDING_EMPTY' | translate }}</p>
  } @else {
    <p-table [value]="invitations" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.EMAIL' | translate }}</th>
          <th>{{ 'ADMIN.USERS.CREATE_ACCESS.TITLE' | translate }}</th>
          <th>{{ 'COMMON.DATE' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invitation>
        <tr>
          <td>
            <strong>{{ invitation.email }}</strong>
            @if (invitation.has_existing_account || invitation.existing_user?.id) {
              <div>
                <small>{{ 'ADMIN.USERS.INVITATION.EXISTING_ACCOUNT' | translate }}</small>
              </div>
            }
          </td>
          <td>
            @if (invitation.payload?.access_mode === 'all-clinics') {
              {{ 'ADMIN.USERS.CREATE_ACCESS.ALL_TITLE' | translate }}
            } @else {
              {{ 'ADMIN.USERS.CREATE_ACCESS.MANUAL_TITLE' | translate }}
            }
          </td>
          <td>{{ invitation.last_sent_at ? (invitation.last_sent_at | date: 'yyyy-MM-dd HH:mm') : '-' }}</td>
          <td class="vc-admin-user-invitations__actions">
            <button pButton type="button" class="p-button-sm p-button-text" (click)="resendInvitation(invitation)">
              {{ 'COMMON.RESEND' | translate }}
            </button>
            <button pButton type="button" class="p-button-sm p-button-text p-button-danger" (click)="cancelInvitation(invitation)">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
